export default __webpack_public_path__ + "static/media/fidelity.cd78738a.jpg";